import { GridCellProps } from "@progress/kendo-react-grid";
import { useContext } from "react";
import useSearchProducts from "ticketing/hooks/useSearchProducts";

import { TRefData } from "../types";
import { BulkImportContext } from "../util";
import { DropDownListCell } from "./DropDownListCell";

export const ProductCell = (props: GridCellProps) => {
  const { fieldConfig, refData: allRefData } = useContext(BulkImportContext);
  const { field } = props;
  /* eslint-disable no-unused-vars */
  const [search, searchResults, loading, , clear] = useSearchProducts();
  /* eslint-enable no-unused-vars */
  const productFieldConfig = fieldConfig?.find(f => f.name === field);
  const lookupName = productFieldConfig?.lookupName!;

  const getData = () => {
    return searchResults?.length ? searchResults : (allRefData?.[lookupName] as TRefData[]);
  };

  if (!productFieldConfig) {
    return <td></td>;
  }

  return (
    <DropDownListCell
      {...props}
      data={getData()}
      fieldConfig={productFieldConfig}
      loading={loading}
      onSearch={search}
      onDone={() => clear()}
    />
  );
};
